import React from "react";
import styled from "styled-components";
import { NavLink, useParams, useLocation } from "react-router-dom";
import { P } from "../../atoms/Texts";

const NavStyle = styled.nav`
  border-bottom: 2px solid #e9e9ed;
  ::-webkit-scrollbar {
    display: none;
  }
`;

const CustomNavLink = styled(NavLink)`
  padding: 9px;
  color: #646a86;
  font-size: 16px;
  // margin-right: 40px;
  border-bottom: solid 2px transparent;
  positon: relative;

  &.active {
    font-weight: 600;
    // background: #442ed0;
    color: #442ed0;
    z-index: 2;
    border-bottom: solid 2px #442ed0;
  }
`;

const CasesNav = ({ theme }) => {
  const { id: orgId, caseId } = useParams();
  const location = useLocation();

  // Check if the current path matches either "/dashboard" or "/dashboard/saved-services"
  const isMatch =
    location.pathname ===
      `/dashboard/organization/${orgId}/case-management/${caseId}` ||
    location.pathname ===
      `/dashboard/organization/${orgId}/case-management/${caseId}/overview`;

  return (
    <NavStyle className="flex flex-no-wrap overflow-x-auto items-center my-8">
      <CustomNavLink
        to={`/dashboard/organization/${orgId}/case-management/${caseId}/overview`}
        className={isMatch ? "active flex items-center" : "flex items-center"}
      >
        <div className="flex flex-grow">
          <P color="inherit" fontFamily="medium" className="mr-2 title">
            Overview
          </P>
        </div>
      </CustomNavLink>
      <CustomNavLink
        to={`/dashboard/organization/${orgId}/case-management/${caseId}/notes`}
        className={({ isActive }) => `flex items-center ${isActive ? "active" : ""}`}
      >
        <div className="flex flex-grow">
          <P color="inherit" fontFamily="medium" className="mr-2 title">
            Notes & Case History
          </P>
        </div>
      </CustomNavLink>

      <CustomNavLink
        to={`/dashboard/organization/${orgId}/case-management/${caseId}/schedule`}
        className={({ isActive }) => `flex items-center ${isActive ? "active" : ""}`}
      >
        <div className="flex flex-grow">
          <P color="inherit" fontFamily="medium" className="mr-2 title">
            Schedule
          </P>
        </div>
      </CustomNavLink>
    </NavStyle>
  );
};

export default CasesNav;
